import React, { FC, PropsWithChildren } from 'react'

import { useRouteMatch } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import styled from 'styled-components'

import { thenModalPath } from 'components/block/Then/Then.paths'
import { mambaLayoutContextId } from 'components/layout/MambaLayout/Context'
import { CreateBaseUrl } from 'components/layout/MambaLayout/CreateContext'
import { UserProfileThen } from 'components/page/UserProfile/UserProfileThen'
import { LayoutPaddingBottom } from 'components/presentational/LayoutPaddingBottom'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { useRedesignLayout } from 'hooks/useRedesign'

const UserProfileContainer = styled.section`
  /* Флекс нужен для отображений инлайновых юни-нотайсов */

  /* https://redmine.mamba.ru/issues/110947 */
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
`

export const UserProfileLayout: FC<PropsWithChildren> = ({ children }) => {
  const match = useRouteMatch()

  if (match) {
    return (
      <CreateBaseUrl
        uid="profile"
        contextId={mambaLayoutContextId}
        baseUrl={match.url}
        basePath={match.path}
        secondary={true}
      >
        <Switch>
          <Route
            path={mergeAllUrls(match.path, thenModalPath)}
            component={UserProfileThen}
            exact={true}
          />
          <Route>
            <ProfileLayoutSwitch>{children}</ProfileLayoutSwitch>
          </Route>
        </Switch>
      </CreateBaseUrl>
    )
  }
  return null
}

const ProfileLayoutSwitch: FC<PropsWithChildren> = ({ children }) => {
  const redesignLayout = useRedesignLayout()

  if (redesignLayout) {
    return children
  }

  return (
    <LayoutPaddingBottom>
      <UserProfileContainer>{children}</UserProfileContainer>
    </LayoutPaddingBottom>
  )
}
